import React from 'react';
import { withRouter } from 'react-router-dom';
import MobileBridge from '../../helpers/MobileBridge';

import SupportForm from '../../components/SupportForm/index';
import MobileHeader from '../../components/MobileHeader';

import './MobileSupportWrapper.scss';

export class MobileSupportWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.navigateBack = this.navigateBack.bind(this);
  }

  componentDidMount() {
    MobileBridge.initialize(this.props.history);
  }

  navigateBack() {
    this.props.history.goBack();
  }

  render() {
    return (
      <div className="mobile-wrapper support-wrapper"> 
        <MobileHeader
          headerTitle={'Support'}
          navigateBack={this.navigateBack}
        />
        <div className="content-wrapper">
          <SupportForm/>
        </div>
      </div>
    );
  }
}

export default withRouter(MobileSupportWrapper);



// WEBPACK FOOTER //
// ./src/mobileWrappers/MobileSupportWrapper/index.js